<template>
    <article
        data-flex="row center"
        v-bind="attributes"
        v-if="i != slides.length || (!hasDiscoverPath && isFinite(i))">

        <section v-if="!(hasDiscoverPath && i == 1)" class="slide__copy h-entry">
            <component 
                class="title title--dash slide__title" 
                :is="titleTag" 
                :aria-label="1 > 2 ? undefined : slide.header.map(el => el).join(' ')"
                :data-maxs="maxSlides"
            >
                <template v-for="(line, l) in slide.header">
                    <span :key="`title-dash-${l}`" data-v-line v-html="line" />
                    <span :key="`title-dashed-${l}`" data-v-space v-if="l < slide.header.length - 1" v-html="`&nbsp;`" />
                </template>
            </component>

            <p 
                class="slide__text slide__text-el p-summary" 
                v-if="slide.body" v-html="slide.body" 
            />

            <!-- <transition appear name="slide" mode="out-in" v-if="hasDiscoverPath && i == 1">
                <SlideScrollButton class="slide__text-el" v-if="!playing" @click="$root.$emit('slide-goto', 1)" />
            </transition> -->
        </section>

        <aside class="slide__circle">
            <SlideContents 
                :slides="slides"
                v-if="hasDiscoverPath && i == 1"
            />
            <circle-box
                v-else
                v-for="(circle, c) in slide.circles"
                v-bind="{
                    ...circleAttrs(
                        !hasDiscoverPath && $store.getters['browser/isTabletLandscape']
                            ? repositionCircle(circle, (c % 2 ? 0 : 180)) 
                            : circle,
                    ),
                    slug: !hasDiscoverPath 
                        ? `recruit` 
                        : currentSlideSlug(slide),
                    simple: !hasDiscoverPath && c,
                    story: circle.story,
                    single: true,
                    alttext: ''
                }"
                :key="`c-${c}-${(i - 1)}`"
                @newPoint="collectPoints"
            />
        </aside>

        <div class="slide__details">
            <template v-if="!$store.getters['browser/isMobile']">
                <DiscoverPath 
                    v-if="hasOutline" 
                    ref="svg-discover"
                    v-bind="{ path }"
                />

                <RecruitmentPath 
                    v-if="!hasDiscoverPath" 
                    ref="svg-recruit"
                    :styles="{
                        '--w': pathWidth,
                        '--o': pathOffset,
                        'pointer-events': 'none',
                    }"
                />

                <!-- <transition appear name="slide" v-if="hasDiscoverPath && !playing">
                    <SlideItemNav :slides="slides" :i="i"  />
                </transition> -->
            </template>

            <SplashImage
                v-if="hasDiscoverPath && hasStudentPath || moduleType == 'recruit'"
                :count="moduleType == 'recruit' && i > 1 ? 2 : 1"
            />

        </div>

    </article>

    <SlideItemLast 
        v-else v-bind="{
            classes: `slide slide--6 slide--last${active}`,
            hasWave: hasDiscoverPath,
            header: slide.header,
            body: slide.body,
            maxSlides,
            attributes,
            active,
        }"
    >
        <template v-slot:circles="slotProps">
            <transition
                appear name="scale"
                mode="out-in"
                v-for="(circle, c) in slide.circles"
                :key="`t-${c}-${(i)}${slotProps.circles}`"
            >
            <circle-box
                :class="{'scaled': !slotProps.circles}"
                :style="{'--x': c + 1}"
                :key="`c-${c}-${(i - 1)}`"
                v-bind="{
                    ...circleAttrs(circle),
                    slug: !hasDiscoverPath 
                        ? `recruit/${circle.slug}` 
                        : currentSlideSlug(slide),
                    simple: !hasDiscoverPath,
                    single: true,
                    alttext: ''
                }"
            >
                <SocialIcons 
                    v-if="/* Just for: /discover-your-story 
                    */hasDiscoverPath && slide.circles.length-1 === c" 
                />
            </circle-box>
            </transition>
        </template>
        
        <!-- <template v-slot:nav>
            <SlideItemNav :slides="slides" :i="i" />
        </template> -->

        <!-- <template v-slot:bullets v-if="hasDiscoverPath && !hasStudentPath">
            <bullet-box
                v-for="(bullet, b) in slide.bullets"
                :key="`b-${b}-${(i - 1)}`"
                :color="bullet.color"
                :size="bullet.size"
                :blur="bullet.blur"
            />
        </template> -->

    </SlideItemLast>

</template>

<script>
import { mapState } from 'vuex'
import { drawify, fillify } from '@/mixins/slidify'
import { imagify } from '@/mixins/images'

// import SlideItemNav         from './SlideItemNav'
import SlideContents        from './SlideContents'
import SlideItemLast        from './SlideItemLast'
import CircleBox            from '../Ui/Circle'
import Socials              from '../Ui/Socials'

import DiscoverPath         from '@/components/Discover/DiscoverPath'
import RecruitmentPath      from '@/components/Recruit/RecruitmentPath'

export default {
    name: 'SlideItem',

    props: {
        slide: Object,
        playing: Boolean,
        hasDiscoverPath: {
            type: Boolean,
            default: true
        },
        hasOutline: {
            type: Boolean,
            default: true
        },
        titleTag: {
            type: String,
            default: 'h2'
        },
    },

    components: {
        // SlideItemNav,
        SlideContents,
        SlideItemLast,
        CircleBox,
        SocialIcons: Socials,
        DiscoverPath,
        RecruitmentPath,
    },

    mixins: [
        imagify,
        drawify,
        fillify,
    ],

    methods: {
        repositionCircle(circle, degree = 0) {
            if ( !circle ) 
                return {}

            const adjusted = {...circle}

            adjusted.desktop = { degree }
            
            return adjusted
        },
    },

    inject: ['moduleType'],

    computed: {
        i() {
            return parseInt([...this.$vnode.key].pop()) + 1
        },
        active() {
            return this.currentSlide===this.i - 1 ? ' is-active' : ''
        },
        classes() {
            return `slide slide--${this.i}${this.active}`
        },
        attributes() {
            const hidden = !this.isMobile() && !this.active
            
            return {
                class: this.classes,
                // 'role': 'group',
                'aria-hidden': hidden,
                // 'aria-roledescription': 'slide',
                // 'aria-label': `${this.i} of ${this.slides.length}`
            }
        },
        maxSlides() {
            if ( this.moduleType === 'discover' ) {
                return this.slides.length - 1
            }
            
            return this.slides.length
        },
        ...mapState({
            hasStudentPath(state, getters) {
                return getters['isUserStudent']
            },
            slides(state, getters) {
                return getters[`${this.moduleType}/slides`]
            },
            currentSlide(state, getters) {
                return getters[`${this.moduleType}/currentSlide`]
            },
        }),
    },
}
</script>
